const EVENT_NAME = 'muzone:avatar-updated';
const hasWindow = typeof window !== 'undefined';

export const emitAvatarUpdate = (userId, url, version = null) => {
    if (!hasWindow || !userId) {
        return;
    }
    const detail = {
        userId: String(userId),
        url: url || null,
        version: version !== null && version !== undefined ? version : null,
    };
    const event = new CustomEvent(EVENT_NAME, { detail });
    window.dispatchEvent(event);
};

export const subscribeAvatarUpdate = (userId, callback) => {
    if (!hasWindow || !userId || typeof callback !== 'function') {
        return () => {};
    }
    const targetId = String(userId);
    const handler = (event) => {
        const { detail } = event;
        if (!detail || detail.userId !== targetId) {
            return;
        }
        // Pass both url and version to callback for cache-busting support
        callback(detail.url, detail.version);
    };
    window.addEventListener(EVENT_NAME, handler);
    return () => {
        window.removeEventListener(EVENT_NAME, handler);
    };
};
